import * as types from './types';

export const showLoader = (payload) => ({ type: types.SHOW, payload });

export const hideLoader = () => ({ type: types.HIDE });
